export default __webpack_public_path__ + "static/media/2_0108.d4b644ef.webp";